import HowDoYouFeelPage from './HowDoYouFeel/howDoYouFeelPage';

export default HowDoYouFeelPage;
